// extracted by mini-css-extract-plugin
export default {"contacts_wrapper":"contacts_contacts_wrapper__gC06c","contacts":"contacts_contacts__iIfQ5","contact_lines_between":"contacts_contact_lines_between__FyxRW"};